<template>
  <GBox
    flex
    class="mobile-redirect-widget-container"
  >
    <GBox
      flex
      direction="column"
    >
      <GBox>
        <a
          rel="noopener"
          href="https://app.adjust.com/hlu961v?deep_link=tysc%3A%2F%2FDashboard&campaign=app_download_android&label=sc_dashboard"
          target="_blank"
          @click="sendGtmEventForMobileApp('Android')"
        >
          <GImage
            src="https://cdn.dsmcdn.com/shared/images/google-play-dark.svg"
            :width="156"
            :height="43"
            default-image="https://cdn.dsmcdn.com/seller-center/shared/common/1x1.png"
          />
        </a>
      </GBox>
      <GBox :mt="10">
        <a
          rel="noopener"
          href="https://app.adjust.com/bs8x9on?deep_link=tysc%3A%2F%2FDashboard&campaign=app_download_ios&label=sc_dashboard"
          target="_blank"
          @click="sendGtmEventForMobileApp('IOS')"
        >
          <GImage
            src="https://cdn.dsmcdn.com/shared/images/app-store.svg"
            :width="156"
            :height="43"
            default-image="https://cdn.dsmcdn.com/seller-center/shared/common/1x1.png"
          />
        </a>
      </GBox>
    </GBox>
    <GBox
      :ml="10"
      class="qr-code-wrapper"
    >
      <GBox class="qr-code-widget-wrapper">
        <GText
          variant="menu-item"
          color="main-grey-500"
          class="qr-code-text"
        >
          QR KOD İLE UYGULAMAYI İNDİRİN!
        </GText>
        <GImage
          :src="qrUrl"
          :width="86"
          :height="86"
          default-image="https://cdn.dsmcdn.com/seller-center/shared/common/1x1.png"
        />
      </GBox>
    </GBox>
  </GBox>
</template>

<script>

import GImage from '@trendyol-js/grace/core/GImage';
import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';

export default {
  name: 'MobileRedirectWidgets',

  components: {
    GBox,
    GImage,
    GText,
  },

  data () {
    return {
      qrUrl: 'https://cdn.dsmcdn.com/shared/images/mobile-app-qr.svg',
    };
  },

  methods: {
    sendGtmEventForMobileApp (platform) {
      this.$gtm.trackEvent({
        event: 'GAEvent',
        eventCategory: 'Onboarding - SC Login',
        eventAction: `SC Mobile APP ${platform}`,
        eventLabel: '-',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@trendyol-js/grace/css/system";

.qr-code-wrapper {
  position: relative;
  flex: 1;
  user-select: none;

  .qr-code-widget-wrapper{
    display: flex;
    flex: 1;
    align-items: center;
    height: 96px;
    background-color: var(--bg-grey-500);
    padding: 5px;
    border-radius: 6px;

    .qr-code-text{
      max-width: 83px;
      padding: 5px 5px 5px 10px;
    }

    ::v-deep .g-image {
      margin-left: auto;
    }

    &.is-open{
      background-color: var(--orange-500);
    }
  }

  .qr-code-modal-wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 0;
    top: 50px;
    background-color: var(--white);
    box-shadow: 0px 8px 16px -8px rgba(39, 49, 66, 0.3);
    border-radius: 10px;
    padding: 20px 30px 30px 30px;

    .close-icon-wrapper {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: -15px;
      padding: 7px;
      background-color: var(--white);
      border-radius: 10px;
    }
  }
}

@media (max-width: 480px) {
  .mobile-redirect-widget-container {
    > div:first-child {
      flex: 1;
    }

    .qr-code-wrapper {
      .qr-code-widget-wrapper {
        justify-content: center;

        .qr-code-text {
          display: none;
        }

        ::v-deep .g-image {
          margin-left: unset;
        }
      }
    }
  }
}
</style>
